import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";

const routes: Routes = [
  { path: "", redirectTo: "home", pathMatch: "full" },
  {
    path: "home",
    loadChildren: () => import("./home/home.module").then(m => m.HomePageModule)
  },

  {
    path: "user-info-form",
    loadChildren: () =>
      import("../app/pages/user-info-form/user-info-form.module").then(m => m.UserInfoFormPageModule)
  },
  {
    path: "login",
    loadChildren: () =>
      import("./pages/login/login.module").then(m => m.LoginPageModule)
  },

  {
    path: "dashboard",
    loadChildren: () =>
      import("./pages/dashboard/dashboard.module").then(
        m => m.DashboardPageModule
      )
  },
  {
    path: "manage-personal-activity",
    loadChildren: () =>
      import("./pages/manage-personal-activity/manage-personal-activity.module").then(
        m => m.ManagePersonalActivityPageModule
      )
  },
  {
    path: "UserInfoForm",
    loadChildren: () =>
      import("./pages/user-info-form/user-info-form.module").then(m => m.UserInfoFormPageModule)
  },
  {
    path: "profile",
    loadChildren: () =>
      import("./pages/profile/profile.module").then(m => m.ProfilePageModule)
  },
  {
    path: "learn",
    loadChildren: () =>
      import("./pages/learn/learn.module").then(m => m.LearnPageModule)
  },
  {
    path: "progressive-survey",
    loadChildren: () =>
      import("./pages/progressive-survey/progressive-survey.module").then(
        m => m.ProgressiveSurveyPageModule
      )
  },
  {
    path: "verify-email",
    loadChildren: () =>
      import("./pages/verify-email/verify-email.module").then(
        m => m.VerifyEmailPageModule
      )
  },
  {
    path: 'completesurvey',
    loadChildren: () => import('./pages/completesurvey/completesurvey.module').then( m => m.CompletesurveyPageModule)
  },
  {
    path: 'main',
    loadChildren: () => import('./pages/main/main.module').then( m => m.MainPageModule)
  },
  {
    path: 'healthdevice',
    loadChildren: () => import('./pages/healthdevice/healthdevice.module').then( m => m.HealthDevicePageModule)
  },
  {
    path: 'survey-content',
    loadChildren: () => import('./pages/survey-content/survey-content.module').then( m => m.SurveyContentPageModule)
  },
  {
    path: 'devicedetails',
    loadChildren: () => import('./pages/devicedetails/devicedetails.module').then( m => m.DevicedetailsPageModule)
  },
  {
    path: 'activity',
    loadChildren: () => import('./pages/activity/activity.module').then( m => m.ActivityPageModule)
  },
  {
    path: 'notification',
    loadChildren: () => import('./pages/notification/notification.module').then( m => m.NotificationPageModule)
  },
  {
    path: 'popover-form',
    loadChildren: () => import('./pages/popover-form/popover-form.module').then( m => m.PopoverFormPageModule)
  },
  {
    path: 'activity-list',
    loadChildren: () => import('./pages/activity-list/activity-list.module').then( m => m.ActivityListPageModule)
  },
  {
    path: 'default-activity',
    loadChildren: () => import('./default-activity/default-activity.module').then( m => m.DefaultActivityPageModule)
  },


  

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, relativeLinkResolution: 'legacy' })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
